var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"not-found"}},[_c('h1',[_vm._v("404")]),_c('p',{staticClass:"text-not-found"},[_vm._v("Lamentamos, mas a página que você procura não existe.")]),_c('a',{attrs:{"href":"/"}},[_vm._v("Voltar para a página inicial")])])
}]

export { render, staticRenderFns }